module.exports = __webpack_public_path__ + "static/media/bannerImg.1cf98c89.png";